import { render } from "./SocialRadio.vue?vue&type=template&id=3e5aaaf8&scoped=true"
import script from "./SocialRadio.vue?vue&type=script&lang=js"
export * from "./SocialRadio.vue?vue&type=script&lang=js"

import "./SocialRadio.vue?vue&type=style&index=0&id=3e5aaaf8&scoped=true&lang=css"

import exportComponent from "/var/www/html/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5aaaf8"]])

export default __exports__